module.exports = __webpack_public_path__ + "img/shield-keyhole.f6059a69.svg";